@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.note-icon {
  height: 18px;
  width: 18px;
  margin: 5px 3px;

  svg {
    height: 100%;
    width: 100%;
    color: @columns--note-icon--fill-color;
  }

  &.has-notes {
    svg {
      color: @columns--note-icon--has-notes--fill-color;
    }
  }
  &:hover {
    cursor: pointer;
  }
}

.note-tooltip {
  width: 100%;
  max-width: 400px;
  max-height: 300px;
  font-size: 12px;
  line-height: 14px;
}

.note-title {
  margin: 0; // reset heading margin
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: @columns--note-title--background-color;
  border-bottom: 1px solid @columns--note-title--border-color;
  border-radius: 5px 5px 0 0;
  .title-text {
    display: inline-block;
    margin-right: 10px;
  }
  .edit-note-btn {
    float: right;
    right: 5px;
    font-size: 13px;
  }
}

.note-body {
  padding: 9px 14px;
  &.edit-mode {
    display: flex;
    .note-body-textarea {
      margin-bottom: 10px;
      min-height: 150px;
      min-width: 150px;
      height: 200px;
      width: 80%;
      resize: both;
      max-width: 320px;
      max-height: 240px;
      order: 1;
      flex: 1 0 auto;
    }
    .note-buttons {
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      justify-content: flex-start;
      order: 2;
      padding-left: 10px;
      button {
        background-color: @columns--note-body-button--background-color;
        border: 1px solid @columns--note-body-button--border-color;
        border-radius: 4px;
        padding: 0;
        margin-bottom: 10px;
        &:hover,
        &:focus {
          background-color: @columns--note-body-button--hover--background-color;
        }
        &.save {
          color: @columns--note-body-button--save--text-color;
          background-color: @columns--note-body-button--save--background-color;
          border-color: transparent;
          svg {
            color: @columns--note-body-button--save--fill-color;
          }
          &:hover,
          &:focus {
            background-color: @columns--note-body-button--save--hover--background-color;
          }
        }
      }
    }
  }
}

.more-notes {
  margin-top: 5px;
  font-style: italic;
}
